import { Component, OnInit } from '@angular/core';
import { Filter } from "../filter";
import { FilterGroupComponent } from "../../filter-group.component";
import { EnumerationService } from "@core/services/enumeration/enumeration.service";

@Component({
  selector: 'app-decoration-or-medal-filter',
  templateUrl: './decoration-or-medal-filter.component.html',
  styleUrls: ['./decoration-or-medal-filter.component.scss']
})
export class DecorationOrMedalFilterComponent extends Filter implements OnInit {

  decorationTypes: any[];

  constructor(public filterGroup: FilterGroupComponent,
    private enumerationService: EnumerationService) {
    super(filterGroup);
  }

  ngOnInit() {
    this.enumerationService.getDecorationTypes$()
      .subscribe(response => {
        this.decorationTypes = response.body;
      });
  }

  updateOperator(operator: string): void {
    this.filterCondition.operator = operator;
    if (this.checkFilterValidity()) {
      this.setAsValid();
      this.filterGroup.applyFilters();
    } else {
      this.filterCondition.isValid = false;
    }
  }

  updateFilter(decorationOrMedal: string): void {
    if (decorationOrMedal !== null) {
      this.filterCondition.value = decorationOrMedal;
      this.setAsValid();
    } else {
      this.isValid = false;
    }
    this.filterGroup.applyFilters();
  }

  private checkFilterValidity(): boolean {
    return this.filterCondition.operator !== null &&
      this.filterCondition.operator !== '' &&
      this.filterCondition.value !== null &&
      this.filterCondition.value !== '';
  }

  getSummary(): string {
    if (this.filterCondition.value) {
      const operator = this.filterCondition.operator === 'is' ? 'is' : 'is not';
      const value = this.filterCondition.value.displayName;
      return `<div>Decoration ${operator} <strong>${value}</strong></div>`;
    }
    return '';
  }

  getQuery(): any {
    if (this.filterCondition.value) {
      return {
        decorationOrMedal: this.filterCondition.value.value,  decorationOrMedalMatch: this.filterCondition.operator === 'is'
      };
    }
    return null;
  }
}
